import Vue from 'vue'
import Vuex from 'vuex'

import {wrapper} from '@utils/wrapper'


import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

import register from '@auth/register/store'
import safe from '@pages/safe/store'
import account from '@pages/account/store'
import about from '@pages/about/store'
import enter from '@pages/enter/store'
import level2 from '@pages/level2/store'
import comment from '@pages/comment/store'
import article from '@pages/article/store'
import canvass from '@pages/canvass/store'
import adwords from '@pages/adwords/store'

Vue.use(Vuex)

const Store =  new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  modules: {
    register,
    safe,
    account,
    about,
    enter,
    level2,
    comment,
    article,
    canvass,
    adwords
  }
})

wrapper.store(Store)

export default Store
